import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AnchorCtaSection = ({
  heading,
  subtitle,
  ctas,
  caption
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    paddingBlock: "1200",
    children: [/*#__PURE__*/_jsx(View, {
      maxInlineSize: "620px",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-700",
        textAlign: "center",
        marginBlock: "0",
        marginBlockEnd: subtitle !== undefined ? '300' : '600',
        display: "block",
        children: heading
      })
    }), subtitle !== undefined && /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      textAlign: "center",
      marginBlockEnd: "500",
      children: subtitle
    }), /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      maxInlineSize: "280px",
      children: ctas
    }), caption !== undefined && /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      textAlign: "center",
      marginBlockStart: "200",
      children: caption
    })]
  });
};